import React, { useEffect, useRef } from 'react';

const BackgroundLights = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let animationFrameId;
        let particles = [];

        const resizeCanvas = () => {
            const parent = canvas.parentElement;
            canvas.width = parent.clientWidth;
            canvas.height = parent.clientHeight;
        };

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        class Particle {
            constructor() {
                this.reset();
                // Initialize with random positions
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
            }

            reset() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                // Increased speed significantly
                this.vx = (Math.random() - 0.5) * 3.0;
                this.vy = (Math.random() - 0.5) * 3.0;
                this.radius = Math.random() * 200 + 150; // Large radius
                // Expanded palette: Blue, Indigo, Violet, Cyan, Yellow, White
                const colors = [
                    { h: 220, s: 85, l: 65 },  // Bright Blue
                    { h: 240, s: 85, l: 65 },  // Bright Indigo
                    { h: 260, s: 85, l: 65 },  // Bright Violet
                    { h: 190, s: 85, l: 65 },  // Bright Cyan
                    { h: 60, s: 90, l: 70 },   // Bright Yellow
                    { h: 0, s: 0, l: 95 }      // White
                ];
                const color = colors[Math.floor(Math.random() * colors.length)];
                // Increased opacity for more vibrant effect
                this.color = `hsla(${color.h}, ${color.s}%, ${color.l}%, 0.5)`;
                this.growth = (Math.random() - 0.5) * 0.5;
            }

            update() {
                this.x += this.vx;
                this.y += this.vy;
                this.radius += this.growth;

                if (this.radius > 400 || this.radius < 100) this.growth *= -1;

                // Wrap around screen
                if (this.x < -this.radius) this.x = canvas.width + this.radius;
                if (this.x > canvas.width + this.radius) this.x = -this.radius;
                if (this.y < -this.radius) this.y = canvas.height + this.radius;
                if (this.y > canvas.height + this.radius) this.y = -this.radius;
            }

            draw() {
                ctx.beginPath();
                const gradient = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.radius);
                gradient.addColorStop(0, this.color);
                gradient.addColorStop(1, 'rgba(0,0,0,0)');

                ctx.fillStyle = gradient;
                // Use screen blending for glowing light effect
                ctx.globalCompositeOperation = 'screen';
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                ctx.fill();
                ctx.globalCompositeOperation = 'source-over';
            }
        }

        const init = () => {
            particles = [];
            // Create about 15 large lights
            for (let i = 0; i < 15; i++) {
                particles.push(new Particle());
            }
        };

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            particles.forEach(particle => {
                particle.update();
                particle.draw();
            });

            animationFrameId = requestAnimationFrame(animate);
        };

        init();
        animate();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            className="absolute inset-0 w-full h-full pointer-events-none mix-blend-screen"
            style={{ opacity: 1.0 }}
        />
    );
};

export default BackgroundLights;
